import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, output } from '@angular/core';

type DisclaimerSelection = 'begin-chat' | 'cancel-chat';

@Component({
  selector: 'app-chat-disclaimer',
  standalone: true,
  imports: [],
  templateUrl: './chat-disclaimer.component.html',
  styleUrl: './chat-disclaimer.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatDisclaimerComponent {
  readonly beginChatSelected = output();
  readonly cancelChatSelected = output();
  
  protected emitSelection(selection: DisclaimerSelection): void {
    if (selection === 'begin-chat') {
      this.beginChatSelected.emit();

      return;
    }

    this.cancelChatSelected.emit();
  }
}
